// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"698":"288fd2ea","939":"e73350cd"}[chunkId] + ".chunk.js";
};